(() => {
  if (customElements.get('yi2c-trust-strip')) return;
  customElements.define('yi2c-trust-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.onClick = event => {
        const button = event.target.closest('.yi2c-trust-strip__toggle');
        if (!button || button.closest('yi2c-trust-strip') !== this) return;
        this.setOpen(button.getAttribute('aria-expanded') === 'true' ? null : button);
      };
      this.onKeydown = event => {
        if (event.key !== 'Escape') return;
        const open = this.querySelector('.yi2c-trust-strip__toggle[aria-expanded="true"]');
        if (!open) return;
        this.setOpen(null);
        open.focus();
        event.preventDefault();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }
    setOpen(selected) {
      for (const button of this.querySelectorAll('.yi2c-trust-strip__toggle')) {
        const open = button === selected;
        button.setAttribute('aria-expanded', String(open));
        this.querySelector(`[id="${button.getAttribute('aria-controls')}"]`).hidden = !open;
      }
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.bound = false;
    }
  });
})();
